<template>
  <button
    :disabled="loading"
    @click="$emit('click', $event)"
    class="button"
  >
    <slot name="title"></slot>
    <slot name="icon"></slot>
    <client-spinner
      v-if="loading"
      class="h-4 w-4"
    />
  </button>
</template>

<script>
import ClientSpinner from "../ClientSpinner.vue"

export default {
  name: "VButton",

  components: {
    ClientSpinner,
  },

  props: {
    loading: { default: false, type: Boolean },
  },

  emits: ["click"],
}
</script>

<style scoped></style>
